import React from 'react';
export function PainPointsSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-[#d6e8fa] text-gray-900 py-10 md:py-14 px-4" data-id="element-157">
      <div className="max-w-4xl mx-auto" data-id="element-158">
        <h2 className="text-xl md:text-2xl lg:text-3xl font-extrabold text-center mb-8 leading-snug" data-id="element-159">
          Si sos mamá o papá de un nene de 1 a 3 años, esto te va a sonar
          familiar:
        </h2>

        <div className="space-y-3 max-w-3xl mx-auto mb-6" data-id="element-160">
          <div className="bg-white/70 border border-blue-200 rounded-lg p-3 flex items-start gap-3 shadow-md" data-id="element-161">
            <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-162">❌</span>
            <p className="text-base md:text-lg font-medium text-gray-700" data-id="element-163">
              Sentir que no estás haciendo lo suficiente para ayudar a tu hijo/a{' '}
              <span className="text-lg ml-1" data-id="element-164">😔</span>
            </p>
          </div>

          <div className="bg-white/70 border border-blue-200 rounded-lg p-3 flex items-start gap-3 shadow-md" data-id="element-165">
            <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-166">❌</span>
            <p className="text-base md:text-lg font-medium text-gray-700" data-id="element-167">
              Preocuparte porque sentís que tu hijo podría estar quedándose
              atrás <span className="text-lg ml-1" data-id="element-168">😰</span>
            </p>
          </div>

          <div className="bg-white/70 border border-blue-200 rounded-lg p-3 flex items-start gap-3 shadow-md" data-id="element-169">
            <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-170">❌</span>
            <p className="text-base md:text-lg font-medium text-gray-700" data-id="element-171">
              Recurrir a las pantallas porque no sabés qué más hacer{' '}
              <span className="text-lg ml-1" data-id="element-172">📱</span>
            </p>
          </div>

          <div className="bg-white/70 border border-blue-200 rounded-lg p-3 flex items-start gap-3 shadow-md" data-id="element-173">
            <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-174">❌</span>
            <p className="text-base md:text-lg font-medium text-gray-700" data-id="element-175">
              Buscar actividades en internet y sentir que ninguna realmente
              funciona o es adecuada <span className="text-lg ml-1" data-id="element-176">😞</span>
            </p>
          </div>
        </div>

        <div className="text-center bg-green-100 border border-green-300 rounded-xl p-4 max-w-3xl mx-auto mb-6" data-id="element-177">
          <p className="text-lg md:text-2xl font-bold text-gray-900 leading-relaxed" data-id="element-178">
            No es tu culpa. Nadie te enseñó cómo hacerlo... pero hoy eso cambia.{' '}
            <span className="text-2xl ml-1" data-id="element-179">💚</span>
          </p>
        </div>

        <div className="text-center" data-id="element-180">
          <button onClick={scrollToCompra} className="bg-orange-500 hover:bg-orange-600 text-white text-lg md:text-xl font-bold py-3 px-6 rounded-full shadow-[0_4px_14px_0_rgba(249,115,22,0.39)] transition-all duration-200 uppercase w-full max-w-lg mx-auto btn-pulse" data-id="element-181">
            🔥 ACCEDER AL KIT AHORA
          </button>
        </div>
      </div>
    </section>;
}